export default "__VITE_ASSET__C$dymg5d__"